
export const SYSTEM_BE = `${process.env.NEXT_PUBLIC_SITE_PROTOCOL}://${process.env.NEXT_PUBLIC_SITE_BE}/api`

export const SYSTEM_URL = `${process.env.NEXT_PUBLIC_SITE_PROTOCOL}://${process.env.NEXT_PUBLIC_SITE_DOMAIN}`

export enum UsernameType {
    EMAIL = "EMAIL",
    INTERNATIONAL_PHONE = "INTERNATIONAL_PHONE",
    PHONE = "PHONE",
    UNKNOWN = "UNKNOWN"
}

export enum Role {
    VISITOR = 'Visitante',
    CLIENT = 'Cliente',
    ADMIN = 'Administrador',
    PUBLIC_RELATIONS = 'Relaciones Públicas',
    ACCESS = 'Acceso',
    TICKET_OFFICE = 'Taquilla',
    SALES = 'Ventas',
    PARTNER = 'Socio',
    CASHIER = 'Caja',
    BARTENDER = 'Barra',
    REGISTRATION_CLERK = 'Registro',
    HOSTESS = 'Hostess',
}

export const STAFF_ROLES = Object.entries(Role).filter(([key]) => {
    return !['VISITOR', 'CLIENT', 'ADMIN'].includes(key);
}).map(([key, value]) => {
    return { label: value, value: key };
});

export const brandSubdomain = (slug: string) => `${process.env.NEXT_PUBLIC_SITE_PROTOCOL}://${slug}.${process.env.NEXT_PUBLIC_SITE_DOMAIN}`
export const brandCustomDomain = (domain: string) => `${process.env.NEXT_PUBLIC_SITE_PROTOCOL}://${domain}`

export const BANNER_WIDTH = 851
export const BANNER_HEIGHT = 315
export const EVENT_SQUARE_BANNER = 400